import { useEffect, useState } from 'react';
import { scrollStore, type ScrollState } from '@/motion/scroll';

export interface HeaderVisibility {
  /** Past the top of the page → the header turns frosted glass and becomes the compact bar. */
  scrolled: boolean;
}

export interface HeaderVisibilityOptions {
  /** Scroll distance (px) after which the header is "scrolled". Default 8. */
  scrolledAfter?: number;
}

/**
 * Header state from the shared scroll store (one scroll source for header, sheen and scrubbing).
 * The header never hides any more (D-342): the navigation stays on screen while the visitor scrolls, so every
 * link is one tap away; past the top it only turns frosted and compact. React state is committed only when
 * `scrolled` actually flips.
 */
export function useHeaderVisibility({
  scrolledAfter = 8,
}: HeaderVisibilityOptions = {}): HeaderVisibility {
  const [state, setState] = useState<HeaderVisibility>({ scrolled: false });

  useEffect(
    () =>
      scrollStore.subscribe((scroll: ScrollState) => {
        const scrolled = scroll.y > scrolledAfter;
        setState((previous) => (previous.scrolled === scrolled ? previous : { scrolled }));
      }),
    [scrolledAfter],
  );

  return state;
}
